import { render, staticRenderFns } from "./RichtextArticle.vue?vue&type=template&id=287cd4c0"
import script from "./RichtextArticle.vue?vue&type=script&lang=js"
export * from "./RichtextArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports